import { createContext, useContext, useState, type ReactNode } from 'react'

interface BannerContextType {
    content: ReactNode
    setBanner: (content: ReactNode) => void
}

const BannerContext = createContext<BannerContextType>({
    content: null,
    setBanner: () => {},
})

export function useBanner() {
    const ctx = useContext(BannerContext)
    if (!ctx) {
        throw new Error('useBanner must be used within a BannerProvider')
    }
    return ctx
}

export function BannerProvider({ children }: { children: ReactNode }) {
    const [content, setBanner] = useState<ReactNode>(null)
    return <BannerContext.Provider value={{ content, setBanner }}>{children}</BannerContext.Provider>
}
